import "./header.css";
import { state } from "../store";
import { useSnapshot } from "valtio";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { useEffect, useRef } from "react";

export default function Header() {
  const {
    showLeva,
    zoomedInBlackClock,
    zoomedInWhiteClock,
    zoomedInBackWallsClock,
    finishedMainLoading,
    finishedIntro,
    hideInstruction,
  } = useSnapshot(state);
  const boxRef = useRef(null);

  return (
    <div className="header-wrapper">
      <div
        className={`header-input-container ${
          !zoomedInBlackClock &&
          !zoomedInWhiteClock &&
          !zoomedInBackWallsClock &&
          finishedMainLoading &&
          finishedIntro
            ? "show"
            : ""
        }`}
      >
        <div className="header-input-container-text">
          <p>SCOUT</p>
          <p>670LX</p>
          <p>SERIES</p>
        </div>
        <div>
          <small>BY DOPPLE MARINE</small>
        </div>
        <div
          className={`header-instruction-container ${
            hideInstruction ? "hide" : ""
          }`}
        >
          Click ON THE MODEL to interact
        </div>
      </div>
    </div>
  );
}
